import { ChangeDetectionStrategy, Component, input, output } from '@angular/core';
import { CommonModule } from '@angular/common';
import { AccordionModule } from 'primeng/accordion';
import { Candidate } from '../../../models/candidate-model';
import { CompanyDisplayComponent } from '../../company-display/company-display.component';
import { WsyCurrencyPipe } from '../../../pipes/wsy-currency.pipe';
import { WsyPercentagePipe } from '../../../pipes/wsy-percentage.pipe';
import { StockAccordionSkeletonComponent } from './skeleton/stock-accordion-skeleton.component';
import { ScoreBadgeComponent } from '../../badges/score-badge.component';
import { PremiumBadgeComponent } from '../../badges/premium-badge.component';
import { WatchlistAddButtonComponent } from '../../watchlists/watchlist-add-button/watchlist-add-button.component';
import { ButtonModule } from 'primeng/button';

@Component({
  selector: 'app-stock-accordion-list',
  standalone: true,
  imports: [
    CommonModule,
    AccordionModule,
    CompanyDisplayComponent,
    WsyCurrencyPipe,
    WsyPercentagePipe,
    StockAccordionSkeletonComponent,
    ScoreBadgeComponent,
    PremiumBadgeComponent,
    WatchlistAddButtonComponent,
    ButtonModule
  ],
  templateUrl: './stock-accordion-list.component.html',
  styleUrls: ['./stock-accordion-list.component.css'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class StockAccordionListComponent {
  // Input properties
  stocks = input<Candidate[]>([]);
  isLoading = input<boolean>(false);

  // Output events
  stockSelected = output<Candidate>();

  // TrackBy function for performance
  trackByTicker(index: number, item: Candidate): string {
    return item.ticker;
  }

  // Handle stock details click
  onStockClick(stock: Candidate): void {
    this.stockSelected.emit(stock);
  }

  stockClicked(ticker: string): void {
    const stock = this.stocks().find(candidate => candidate.ticker === ticker);

    if (stock) {
      this.onStockClick(stock);
    }
  }
}
